module.exports = __webpack_public_path__ + "static/media/strongher6.d8a37970.jpg";